import React from "react";
import { HiChevronRight } from "react-icons/hi2";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Image from "next/image";
import Link from "next/link";

export default function DesktopSection({ reverse = false, collectionItems }) {
  const {
    heading = "",
    subHeading = "",
    ctaText = "",
    pageLink = "",
    leftImage = {},
    rightImage = {},
    description = "",
    bottomImage = {},
    headingPosition = "left",
  } = collectionItems || {};

  const reverseClass = headingPosition === "right" ? "md:flex-row-reverse" : "";
  return (
    <>
      <div className={`row koh-top-row flex flex-row gap-[0.8px] ${reverseClass}`}>
        <div className="`w-full md:w-2/5 flex flex-col ">
          <Link href={pageLink} className="!no-underline">
            <div
              className={`koh-collection-item-title flex flex-col items-center`}
            >
              <div
                className={`koh-collection-item-title-inne flex flex-col items-center mt-12`}
              >
                <h6 className="reveTxt mb-[10px]">{heading}</h6>
                <p className="statement">{subHeading}</p>
                <span className="shopStatement mt-[74px] inline-flex items-center gap-1 hover:underline cursor-pointer">
                  <span>{ctaText} </span>
                  <HiChevronRight className="mt-1 w-5 h-5" />
                </span>
              </div>
            </div>
          </Link>
          <div className="koh-collection-top-small-img mt-14">
            <Image
              className="h-full w-full object-cover block right-img "
              width={407}
              height={383}
              alt={leftImage?.fields?.altText}
              src={leftImage?.fields?.imageUrl}
            />
          </div>
        </div>
        <div className="w-full md:w-3/5 koh-collection-top-big-img">
          <Link href={pageLink}>
            <Image
              className="min-h-full w-full object-cover block big-image"
              width={572}
              height={650}
              alt={rightImage?.fields?.altText}
              src={rightImage?.fields?.imageUrl}
            />
          </Link>
        </div>
      </div>

      <div
        className={`row koh-bottom-row flex flex-row  justify-center items-center max-w-[1000px] gap-4 ${reverseClass}`}
      >
        <div className="w-full md:w-4/12  flex  justify-center items-center  mx-auto">
          <div
            className={`koh-collection-item-title-inner flex w-full lg:w-5/5 items-center justify-end`}
          >
            <p className="koh-para text-sm shopStatement">{description}</p>
          </div>
        </div>

        <div className="w-full md:w-5/12 koh-collection-top-big-img">
          <Link href={pageLink}>
            <Image
              className="h-suto w-full object-cover block right-img"
              width={408}
              height={384}
              alt={bottomImage?.fields?.altText}
              src={bottomImage?.fields?.imageUrl}
            />
          </Link>
        </div>
        <div class="w-full md:w-2/12">&nbsp;</div>
      </div>
    </>
  );
}
